import React, { ReactElement } from "react";
import { getXOffset, getYOffset } from "./utils";
import { LabelLineProps } from "./types";

const LabelLine = ({
  cx,
  cy,
  midAngle,
  middleRadius,
  radius,
  constantOffsetNumber,
}: LabelLineProps): ReactElement => {
  const xStart = cx + getXOffset(middleRadius, midAngle);
  const yStart = cy + getYOffset(middleRadius, midAngle);

  const offSetMiddle = constantOffsetNumber * radius - middleRadius;
  const xMiddle = cx + getXOffset(offSetMiddle, midAngle);
  const yMiddle = cy + getYOffset(offSetMiddle, midAngle);

  const offSetEnd = 2.5 * radius - middleRadius;
  const xEnd = cx + getXOffset(offSetEnd, midAngle);
  return (
    <polyline
      style={{
        opacity: "0.3",
        fill: "none",
        stroke: "rgb(var(--color-neutral-secondary-20))",
        strokeWidth: "1px",
        strokeDasharray: "1",
      }}
      points={`${xStart},${yStart} ${xMiddle},${yMiddle} ${xEnd},${yMiddle}`}
    />
  );
};

export default LabelLine;
